import Vue from 'vue';
import Component from 'vue-class-component';
import { MEETING_SHORT_NAV, EVENT_TYPES, SOCKET_EVENTS, MEETING_EVENTS, _MEETINGS_STORE, CRYPTPAD_MEETINGS, MEETING_TYPES_IDS } from '@/meetings/values/meetings.values';
import KEYS from '@/values/keys';
import { CLOSE_BOARD_SOCKET_DISCONNECTING_EVENT, FORWARD_PRESENTATION_MESSAGES_EVENT, _APP_STORE } from '@/core/values/app.values';
import { AUTH_STORE } from '@/auth/store/auth.store';
import EdPresentationModeFactory from '@/content/factories/ed-presentation-mode.factory';
import WebSocketMessageRequest from '@/content/models/web-socket-message-request.model';
import * as PRESENTATION_VALUES from '@/content/values/ed-presentation-mode.values';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { User } from '../models/user.model';
import { ED_MODAL_EVENTS } from '@/plugins/ed-modal/ed-modal.plugin';
import BrowserService from '@/providers/browser-utils/browser.service';
import { MeetingsService } from '@/meetings/services/meetings.service';
import { PresentationModeStatusMapper } from '../mappers/presentation-mode-status.mapper';
import { IPresentationModeStatus } from '../interfaces/presentation-mode-status.interface';
import PresentationModeViewerMixin from '@/content/mixins/ed-presentation-mode-viewer.mixin';

@Component({})
export default class NavMeetingsMixin extends Vue {

  public navMeetingMenuID: string = 'EdNavMeetings';
  public navMeeting:any = [];
  private processors : any = {
      ShortMenu: this.loadShortMenu,
      StudentToggle: this.loadStudentToggle
  };
  private courseVewerMeetingId: number = -4;
  private subscribeStore : Function;

  get currentMeetingData() {
    return this.$store.state.MeetingsStore.currentMeetingData;
  } 

  get isPublisher() : boolean {
    return this.$store.state.AuthStore.role === KEYS.ROLES.PUBLISHER;
  }

  get userInfo(): User {
    return this.$store.state.AuthStore.user;
  }

  get presentationModeMeetings(): number[] {
    return this.$store.state.MeetingsStore.presentationModeMeetings;
  }

  get existsMeeting(): boolean {
    return this.presentationModeMeetings.includes(this.currentMeetingData.meetingId);
  }

  get isPresentationModeGuestTeacher() : boolean {
    return this.$store.state.MeetingsStore.isPresentationModeGuestTeacher;
  }

  get isActivePresenterTeacher() : boolean {
    return this.$store.state.MeetingsStore.isActivePresenterTeacher;
  }

  get isShowingChangePresenter() : boolean {
    return this.$store.state.MeetingsStore.isShowingChangePresenter;
  }

  get isWebView(): boolean {
    return this.$store.state.AppStore.webview;
  }

  public joinMeetingMenu(meetingType : number) {
      if(!this.isPublisher || meetingType === this.currentMeetingData.meetingType || this.isPresentationModeGuestTeacher) {
        this.checkPresentationModeStatus()
      } else {
        this.updateMeetingData(meetingType);
        this.updateMeetingLocation();
      }
      
  }

  private emitMeetingConnected(cleanMeeting : boolean = true) : void {      
      if(this.isPublisher && !this.isPresentationModeGuestTeacher) {
        this.updateMeetingLocation(cleanMeeting);
      } else {
        let data = {roomId: this.currentMeetingData.meetingId, device: BrowserService.getFullBrowserInfo()};
        let message : WebSocketMessageRequest = EdPresentationModeFactory.createWebSocketMessageRequest(EVENT_TYPES.subscribe, String(this.currentMeetingData.meetingId), false, JSON.stringify(data));
        if(this.isPresentationModeGuestTeacher){
          message = EdPresentationModeFactory.createWebSocketMessageRequestWithUserType(EVENT_TYPES.subscribe, String(this.currentMeetingData.meetingId), PRESENTATION_VALUES.GUEST_TACHER_ROLE, false, JSON.stringify(data));
        }
        this.$EdSocket.emit(SOCKET_EVENTS.connect, message);
      }

  }

  private updateMeetingData(meetingType: number) {
    this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_CURRENT_MEETING_DATA,
      { ...this.currentMeetingData, meetingType });

    this.$edEventBus.$emit(MEETING_EVENTS.CHANGE_MEETING_SHORT_MENU, {
      'meetingId': this.currentMeetingData.meetingId,
      'id': meetingType, 
      'classId': this.currentMeetingData.classId
    });
  }

  private updateMeetingLocation(cleanMeeting : boolean = true) {
      let dataSend = {meetingType :  this.currentMeetingData.meetingType};
      let message : WebSocketMessageRequest = EdPresentationModeFactory.createWebSocketMessageRequest(EVENT_TYPES.shortMenu, String(this.currentMeetingData.meetingId), false, JSON.stringify(dataSend));
      if(cleanMeeting) {
        this.$store.commit(_MEETINGS_STORE.MUTATIONS.CLEAN_MEETING_PAGE);
      }
      this.$EdSocket.emit(SOCKET_EVENTS.updateLocation, message); 
  }

  private validateMeetingsParamsToInit() : void {
      if(this.$store.state.AppStore.presentationSocketConnected && this.$store.state.AuthStore.user.userId){
          this.emitMeetingConnected();
          this.subscribeStore();
      }
  }

  private validateMeetingsStoreValues(){
      this.subscribeStore = this.$store.subscribe((mutation) => {
          if(mutation.type === _APP_STORE.MUTATIONS.SET_PRESENTATION_SOCKET_CONNECTED || mutation.type === AUTH_STORE.MUTATIONS.SET_USER_INFO) { 
            this.validateMeetingsParamsToInit();
          }
      });
  }

  private loadUserMessages(data : any) {
    if(data.messageType === EVENT_TYPES.allMessages) {
       let messageHigher = null;

        for(let key in data.messages){
            if(!messageHigher || data.messages[key].time > messageHigher.time){
                messageHigher = data.messages[key];
            }
        }
        
        if(messageHigher && messageHigher.messages) {
          if(messageHigher.messages.ShortMenu) {
              let data = JSON.parse(messageHigher.messages.ShortMenu.content);
              this.processors.ShortMenu(data);
          } 
          if(messageHigher.messages.StudentToggle){
              let data = JSON.parse(messageHigher.messages.StudentToggle.content);
              this.processors.StudentToggle(data);
          }
        }
    }
  }

  private loadEventsMessages(message : any) {
    if(message && message.messageType && this.processors[message.messageType] && message.topicId === this.currentMeetingData.meetingId){
        let data = JSON.parse(message.content);
        this.processors[message.messageType](data);
    }
  }

  private loadShortMenu(data : any) {
    this.navMeeting = MEETING_SHORT_NAV.filter(option =>
        option.id === data.meetingType
    );
    this.$store.commit(_MEETINGS_STORE.MUTATIONS.CLEAN_MEETING_PAGE);
    this.updateMeetingData(data.meetingType);
    if (this.courseVewerMeetingId !== data.meetingType) {
      this.$edEventBus.$emit(CLOSE_BOARD_SOCKET_DISCONNECTING_EVENT);
      if(!this.isPublisher || this.isPresentationModeGuestTeacher){
        this.$EdToast.hide();
        if(this.isShowingChangePresenter) {
          this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_SHOWING_CHANGE_PRESENTER, false);
          this.$EdModal.$emit(ED_MODAL_EVENTS.ED_MODAL_CONFIRMATION_HIDE);
        }
      }
    }
  }

  private leaveTeacherPresentation() : void {
    if (!this.existsMeeting || (this.isPresentationModeGuestTeacher && !this.isActivePresenterTeacher)) {
      const message = this.isWebView ? 'leaveTeacherWebView' : 'leaveTeacher';
      this.$EdToast.create(
          {
              msg:  `${this.$i18n.t('meetings.presentationMode.' + message)}`,
              type: TOAST_TYPES.WARNING,
              top: this.isWebView ? '0rem' : '3rem'
          }
      );
      this.navMeeting = [];
    }
  }

  private loadStudentToggle(data : any) {
      if(!this.isPublisher || this.isPresentationModeGuestTeacher) {
          let studentToggle = data.toggle;
          let meetingType = data.meetingType;
          this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_CURRENT_MEETING_DATA,
            { ...this.currentMeetingData, studentToggle });
          if(CRYPTPAD_MEETINGS.includes(meetingType)) {
            if(studentToggle) {
                this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_MEETING_PAGE, this.currentMeetingData.viewUrl);
            } else {
                this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_MEETING_PAGE, this.currentMeetingData.editUrl);
            } 
          }
          this.$edEventBus.$emit(MEETING_EVENTS.SET_READ_ONLY_STUDENT);
      }
  }

  private async checkPresentationModeStatus() {
    let statusResponse = await MeetingsService.getPresentationModeStatus(this.currentMeetingData.meetingId);
    let status = PresentationModeStatusMapper(statusResponse);
    this.applyPresentationModeStatus(status);
  }

  private applyPresentationModeStatus(presentationModeStatus: IPresentationModeStatus) {
    if(this.currentMeetingData.meetingType !== presentationModeStatus.meetingType){
      this.updateMeetingData(presentationModeStatus.meetingType);
    }
    
    //Update data when PM is COURSE_VIEWER
    if(presentationModeStatus.meetingType === MEETING_TYPES_IDS.COURSE_VIEWER){
     this.$edEventBus.$emit(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.REFRESH_SATUS, presentationModeStatus);
    }

    //Common updates
    if(this.currentMeetingData.studentToggle !== presentationModeStatus.readOnly)
        this.loadStudentToggle({toggle: presentationModeStatus.readOnly});
  }

  private validateState() : void {
    if(this.$store.state.AppStore.presentationSocketConnected && this.$store.state.AuthStore.user.userId){
        this.emitMeetingConnected();
    }else {
        this.validateMeetingsStoreValues();
    }
  }

  private forwardMessages() : void {
    this.emitMeetingConnected(false);
    this.emitPresentationConnect();
  }

  private emitPresentationConnect() {
    if (this.courseVewerMeetingId !== this.currentMeetingData.meetingId && this.isPublisher && !this.isPresentationModeGuestTeacher) {
        let data = {roomId: this.currentMeetingData.meetingId, device: BrowserService.getFullBrowserInfo()};
      let message: WebSocketMessageRequest = EdPresentationModeFactory.createWebSocketMessageRequest(PRESENTATION_VALUES.EVENT_TYPES.subscribe,
        String(this.currentMeetingData.meetingId), false, JSON.stringify(data));
      this.$EdSocket.emit(PRESENTATION_VALUES.SOCKET_EVENTS.connect, message);
    }
  }



  private closeAfterEvents() : void {
    this.$edEventBus.$off(PRESENTATION_VALUES.VALIDATE_PRESENTATION_STUDENT_CONNECT_EVENT, this.validateState);
    this.$edEventBus.$off(FORWARD_PRESENTATION_MESSAGES_EVENT, this.forwardMessages);
    this.$edEventBus.$off(MEETING_EVENTS.ALL_USER_MESSAGES, this.loadUserMessages);
    this.$edEventBus.$off(MEETING_EVENTS.RESPONSE_EVENT, this.loadEventsMessages);
    this.$edEventBus.$off(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.LEAVE_TEACHER_EVENT, this.leaveTeacherPresentation);
  }

  mounted() {
    
    this.closeAfterEvents();
    
    this.validateState();
    this.$edEventBus.$on(PRESENTATION_VALUES.VALIDATE_PRESENTATION_STUDENT_CONNECT_EVENT, this.validateState);
    this.$edEventBus.$on(FORWARD_PRESENTATION_MESSAGES_EVENT, this.forwardMessages);
    if (!this.isPublisher || this.isPresentationModeGuestTeacher) {
      this.$edEventBus.$on(MEETING_EVENTS.ALL_USER_MESSAGES, this.loadUserMessages);
      this.$edEventBus.$on(MEETING_EVENTS.RESPONSE_EVENT, this.loadEventsMessages);
      this.$edEventBus.$on(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.LEAVE_TEACHER_EVENT, this.leaveTeacherPresentation);
    } else {
      this.navMeeting = MEETING_SHORT_NAV;
    }
  }

  beforeDestroy() {
    this.$edEventBus.$off(PRESENTATION_VALUES.VALIDATE_PRESENTATION_STUDENT_CONNECT_EVENT, this.validateState);
    this.$edEventBus.$off(FORWARD_PRESENTATION_MESSAGES_EVENT, this.forwardMessages);
      if(!this.isPublisher || this.isPresentationModeGuestTeacher){
        this.$edEventBus.$off(MEETING_EVENTS.ALL_USER_MESSAGES, this.loadUserMessages);
        this.$edEventBus.$off(MEETING_EVENTS.RESPONSE_EVENT, this.loadEventsMessages);
        this.$edEventBus.$off(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.LEAVE_TEACHER_EVENT);
        this.$EdToast.hide();
      }
  }
}
